// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** American Samoa */
const AS = /^(?:684(?:2(?:48|5[2468]|7[246])|7(?:3[13]|70|82))\d{4})$/;

export default AS;
